(function ($) {
    svg4everybody();
    $(function () {
        // Menu Burger
        $('.js-burger').click(function (e) {
            e.preventDefault();

            var $this = $(this),
                target = $($this.attr('href'));

            $this.toggleClass('burger--active');
            target.slideToggle();
        });

        $('body').on('click', '.js-display-sub-menu', function (e) {
            e.preventDefault();

            $(this).siblings('.sub-menu').slideToggle();
        });

        $('.js-testimonial-slider').slick({
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '33%',
            responsive: [{
                breakpoint: 1151,
                settings: {
                    centerMode: false
                }
            }, {
                breakpoint: 768,
                settings: "unslick"
            }]

        });

        $('.js-image-slider').slick({
            centerMode: true,
            centerPadding: '25%',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: '50px'
                    }
                }
            ]
        });

        $('.js-client-slider').each(function () {
            var $this = $(this),
                rtl = ($this.data('direction') == 'right');

            $this.slick({
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '20%',
                rtl: rtl,
                autoplay: true,
                arrows: false,
                responsive: [{
                    breakpoint: 1152,
                    settings: {
                        centerMode: false
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false
                    }
                }]
            })
        });

        $('.js-progress').each(function () {
            var self = this;
            var bar = new ProgressBar.Circle(this, {
                easing: 'easeInOut',
                strokeWidth: 5,
                duration: 1400,
                trailColor: '#E6E6E6'
            });
            bar.path.setAttribute('stroke-linecap', 'round');

            $(self).waypoint({
                handler: function () {
                    bar.animate(self.getAttribute('data-progress'));
                },
                offset: 'bottom-in-view'
            })
        });

        // Afficher tous les connecteurs
        $('.js-connector-all').click(function (e) {
            var $this = $(this);

            e.preventDefault();

            $this.parents('.connector-list__categories').find('a').removeClass('is-active');
            $this.addClass('is-active')
                .parents('.connector-list')
                    .find('.connector').show();
        });

        // Filter les connecteurs
        $('.js-connector-filter').click(function (e) {
            var $this = $(this);
            e.preventDefault();

            $this.parents('.connector-list__categories').find('a').removeClass('is-active');
            $this.addClass('is-active')
                .parents('.connector-list')
                    .find('.connector').hide()
                        .filter($this.data('class')).show();
        });

        // Recherche dans les livres blancs
        $('.js-case-studies-search').each(function(){
            var $this = $(this),
                $container = $this.closest('.container');

            new List($container[0], {
                valueNames: [
                    'cs-teaser__title',
                    'cs-teaser__subtitle',
                    'cs-teaser__legend',
                    'cs-teaser__excerpt',
                    { name: 'cs-teaser__image-wrapper', attr: 'href' }
                ],
                listClass: 'item-list',
                searchClass: 'searchform__field'
            });
        });

        $('#content').imagesLoaded(function(){
            $('.js-rellax').each(function () {
                new Rellax(this, {
                    center: true,
                    speed: -2
                });
            });
        });

        $('.js-tabs').on('click', '.js-tabs-link', function(e){
            e.preventDefault();
            var content = $(this.getAttribute('href'));

            $('html, body').animate({scrollTop: content.offset().top - 80}, 300);
        });

        $('.js-back-to-top').click(function (e) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, 500);
        });

        $('.js-accordion').on('click', '.accordion__head', function(e) {
            e.preventDefault();
            var accordion = $(e.delegateTarget);

            accordion.find('.accordion__body').slideToggle();
            accordion.toggleClass('is-active');
        });

        var header = $('.js-header'),
            headerHeight = header.outerHeight(),
            headerDark = header.hasClass('dark')
        ;

        $(window).scroll(function () {
            if ($(this).scrollTop() > headerHeight) {
                header.addClass('header--sticky');
                headerDark && header.removeClass('dark');
            } else {
                header.removeClass('header--sticky');
                headerDark && header.addClass('dark');
            }
        });
    });
})(jQuery);
